// oxlint-disable-next-line import/no-duplicates
import type { EmojiNodeDataProvider } from '@atlaskit/editor-plugin-emoji/EmojiNodeDataProvider';
import type { EmojiPluginOptions } from '@atlaskit/editor-plugin-emoji/emojiPluginType';
import type { EmojiProvider } from '@atlaskit/emoji/types';

interface Props {
	options: Pick<EmojiPluginOptions, 'contentId'> | undefined;
	providers: {
		emojiNodeDataProvider: EmojiNodeDataProvider | undefined;
		emojiProvider: Promise<EmojiProvider> | undefined;
	};
}

export function emojiPluginOptions({ options, providers }: Props): EmojiPluginOptions {
	return {
		contentId: options?.contentId,
		emojiProvider: providers.emojiProvider,
		emojiNodeDataProvider: providers.emojiNodeDataProvider,
	};
}
